import i18next from "@/locale";

export const defaultCounties = [
  {
    name: "Afghanistan",
    code: "AF",
  },
  {
    name: "Albania",
    code: "AL",
  },
  {
    name: "Algeria",
    code: "DZ",
  },
  {
    name: "Andorra",
    code: "AD",
  },
  {
    name: "Angola",
    code: "AO",
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
  },
  {
    name: "Argentina",
    code: "AR",
  },
  {
    name: "Armenia",
    code: "AM",
  },
  {
    name: "Australia",
    code: "AU",
  },
  {
    name: "Austria",
    code: "AT",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
  },
  {
    name: "Bahamas",
    code: "BS",
  },
  {
    name: "Bahrain",
    code: "BH",
  },
  {
    name: "Bangladesh",
    code: "BD",
  },
  {
    name: "Barbados",
    code: "BB",
  },
  {
    name: "Belarus",
    code: "BY",
  },
  {
    name: "Belgium",
    code: "BE",
  },
  {
    name: "Belize",
    code: "BZ",
  },
  {
    name: "Benin",
    code: "BJ",
  },
  {
    name: "Bhutan",
    code: "BT",
  },
  {
    name: "Bolivia",
    code: "BO",
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
  },
  {
    name: "Botswana",
    code: "BW",
  },
  {
    name: "Brazil",
    code: "BR",
  },
  {
    name: "Brunei",
    code: "BN",
  },
  {
    name: "Bulgaria",
    code: "BG",
  },
  {
    name: "Burkina Faso",
    code: "BF",
  },
  {
    name: "Burundi",
    code: "BI",
  },
  {
    name: "Cabo Verde",
    code: "CV",
  },
  {
    name: "Cambodia",
    code: "KH",
  },
  {
    name: "Cameroon",
    code: "CM",
  },
  {
    name: "Canada",
    code: "CA",
  },
  {
    name: "Central African Republic",
    code: "CF",
  },
  {
    name: "Chad",
    code: "TD",
  },
  {
    name: "Chile",
    code: "CL",
  },
  {
    name: "China",
    code: "CN",
  },
  {
    name: "Colombia",
    code: "CO",
  },
  {
    name: "Comoros",
    code: "KM",
  },
  {
    name: "Congo (Congo-Brazzaville)",
    code: "CG",
  },
  {
    name: "Costa Rica",
    code: "CR",
  },
  {
    name: "Croatia",
    code: "HR",
  },
  {
    name: "Cuba",
    code: "CU",
  },
  {
    name: "Cyprus",
    code: "CY",
  },
  {
    name: "Czechia",
    code: "CZ",
  },
  {
    name: "Denmark",
    code: "DK",
  },
  {
    name: "Djibouti",
    code: "DJ",
  },
  {
    name: "Dominica",
    code: "DM",
  },
  {
    name: "Dominican Republic",
    code: "DO",
  },
  {
    name: "Ecuador",
    code: "EC",
  },
  {
    name: "Egypt",
    code: "EG",
  },
  {
    name: "El Salvador",
    code: "SV",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
  },
  {
    name: "Eritrea",
    code: "ER",
  },
  {
    name: "Estonia",
    code: "EE",
  },
  {
    name: "Eswatini",
    code: "SZ",
  },
  {
    name: "Ethiopia",
    code: "ET",
  },
  {
    name: "Fiji",
    code: "FJ",
  },
  {
    name: "Finland",
    code: "FI",
  },
  {
    name: "France",
    code: "FR",
  },
  {
    name: "Gabon",
    code: "GA",
  },
  {
    name: "Gambia",
    code: "GM",
  },
  {
    name: "Georgia",
    code: "GE",
  },
  {
    name: "Germany",
    code: "DE",
  },
  {
    name: "Ghana",
    code: "GH",
  },
  {
    name: "Greece",
    code: "GR",
  },
  {
    name: "Grenada",
    code: "GD",
  },
  {
    name: "Guatemala",
    code: "GT",
  },
  {
    name: "Guinea",
    code: "GN",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
  },
  {
    name: "Guyana",
    code: "GY",
  },
  {
    name: "Haiti",
    code: "HT",
  },
  {
    name: "Honduras",
    code: "HN",
  },
  {
    name: "Hungary",
    code: "HU",
  },
  {
    name: "Iceland",
    code: "IS",
  },
  {
    name: "India",
    code: "IN",
  },
  {
    name: "Indonesia",
    code: "ID",
  },
  {
    name: "Iran",
    code: "IR",
  },
  {
    name: "Iraq",
    code: "IQ",
  },
  {
    name: "Ireland",
    code: "IE",
  },
  {
    name: "Israel",
    code: "IL",
  },
  {
    name: "Italy",
    code: "IT",
  },
  {
    name: "Jamaica",
    code: "JM",
  },
  {
    name: "Japan",
    code: "JP",
  },
  {
    name: "Jordan",
    code: "JO",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
  },
  {
    name: "Kenya",
    code: "KE",
  },
  {
    name: "Kiribati",
    code: "KI",
  },
  {
    name: "Korea (North)",
    code: "KP",
  },
  {
    name: "Korea (South)",
    code: "KR",
  },
  {
    name: "Kuwait",
    code: "KW",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
  },
  {
    name: "Laos",
    code: "LA",
  },
  {
    name: "Latvia",
    code: "LV",
  },
  {
    name: "Lebanon",
    code: "LB",
  },
  {
    name: "Lesotho",
    code: "LS",
  },
  {
    name: "Liberia",
    code: "LR",
  },
  {
    name: "Libya",
    code: "LY",
  },
  {
    name: "Liechtenstein",
    code: "LI",
  },
  {
    name: "Lithuania",
    code: "LT",
  },
  {
    name: "Luxembourg",
    code: "LU",
  },
  {
    name: "Madagascar",
    code: "MG",
  },
  {
    name: "Malawi",
    code: "MW",
  },
  {
    name: "Malaysia",
    code: "MY",
  },
  {
    name: "Maldives",
    code: "MV",
  },
  {
    name: "Mali",
    code: "ML",
  },
  {
    name: "Malta",
    code: "MT",
  },
  {
    name: "Marshall Islands",
    code: "MH",
  },
  {
    name: "Mauritania",
    code: "MR",
  },
  {
    name: "Mauritius",
    code: "MU",
  },
  {
    name: "Mexico",
    code: "MX",
  },
  {
    name: "Micronesia",
    code: "FM",
  },
  {
    name: "Moldova",
    code: "MD",
  },
  {
    name: "Monaco",
    code: "MC",
  },
  {
    name: "Mongolia",
    code: "MN",
  },
  {
    name: "Montenegro",
    code: "ME",
  },
  {
    name: "Morocco",
    code: "MA",
  },
  {
    name: "Mozambique",
    code: "MZ",
  },
  {
    name: "Myanmar",
    code: "MM",
  },
  {
    name: "Namibia",
    code: "NA",
  },
  {
    name: "Nauru",
    code: "NR",
  },
  {
    name: "Nepal",
    code: "NP",
  },
  {
    name: "Netherlands",
    code: "NL",
  },
  {
    name: "New Zealand",
    code: "NZ",
  },
  {
    name: "Nicaragua",
    code: "NI",
  },
  {
    name: "Niger",
    code: "NE",
  },
  {
    name: "Nigeria",
    code: "NG",
  },
  {
    name: "North Macedonia",
    code: "MK",
  },
  {
    name: "Norway",
    code: "NO",
  },
  {
    name: "Oman",
    code: "OM",
  },
  {
    name: "Pakistan",
    code: "PK",
  },
  {
    name: "Palau",
    code: "PW",
  },
  {
    name: "Panama",
    code: "PA",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
  },
  {
    name: "Paraguay",
    code: "PY",
  },
  {
    name: "Peru",
    code: "PE",
  },
  {
    name: "Philippines",
    code: "PH",
  },
  {
    name: "Poland",
    code: "PL",
  },
  {
    name: "Portugal",
    code: "PT",
  },
  {
    name: "Qatar",
    code: "QA",
  },
  {
    name: "Romania",
    code: "RO",
  },
  {
    name: "Russia",
    code: "RU",
  },
  {
    name: "Rwanda",
    code: "RW",
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
  },
  {
    name: "Saint Lucia",
    code: "LC",
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
  },
  {
    name: "Samoa",
    code: "WS",
  },
  {
    name: "San Marino",
    code: "SM",
  },
  {
    name: "Sao Tome and Principe",
    code: "ST",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
  },
  {
    name: "Senegal",
    code: "SN",
  },
  {
    name: "Serbia",
    code: "RS",
  },
  {
    name: "Seychelles",
    code: "SC",
  },
  {
    name: "Sierra Leone",
    code: "SL",
  },
  {
    name: "Singapore",
    code: "SG",
  },
  {
    name: "Slovakia",
    code: "SK",
  },
  {
    name: "Slovenia",
    code: "SI",
  },
  {
    name: "Solomon Islands",
    code: "SB",
  },
  {
    name: "Somalia",
    code: "SO",
  },
  {
    name: "South Africa",
    code: "ZA",
  },
  {
    name: "South Sudan",
    code: "SS",
  },
  {
    name: "Spain",
    code: "ES",
  },
  {
    name: "Sri Lanka",
    code: "LK",
  },
  {
    name: "Sudan",
    code: "SD",
  },
  {
    name: "Suriname",
    code: "SR",
  },
  {
    name: "Sweden",
    code: "SE",
  },
  {
    name: "Switzerland",
    code: "CH",
  },
  {
    name: "Syria",
    code: "SY",
  },
  {
    name: "Taiwan",
    code: "TW",
  },
  {
    name: "Tajikistan",
    code: "TJ",
  },
  {
    name: "Tanzania",
    code: "TZ",
  },
  {
    name: "Thailand",
    code: "TH",
  },
  {
    name: "Timor-Leste",
    code: "TL",
  },
  {
    name: "Togo",
    code: "TG",
  },
  {
    name: "Tonga",
    code: "TO",
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
  },
  {
    name: "Tunisia",
    code: "TN",
  },
  {
    name: "Turkey",
    code: "TR",
  },
  {
    name: "Turkmenistan",
    code: "TM",
  },
  {
    name: "Tuvalu",
    code: "TV",
  },
  {
    name: "Uganda",
    code: "UG",
  },
  {
    name: "Ukraine",
    code: "UA",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
  },
  {
    name: "United Kingdom",
    code: "GB",
  },
  {
    name: "United States of America",
    code: "US",
  },
  {
    name: "Uruguay",
    code: "UY",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
  },
  {
    name: "Vanuatu",
    code: "VU",
  },
  {
    name: "Vatican City",
    code: "VA",
  },
  {
    name: "Venezuela",
    code: "VE",
  },
  {
    name: "Vietnam",
    code: "VN",
  },
  {
    name: "Yemen",
    code: "YE",
  },
  {
    name: "Zambia",
    code: "ZM",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
  },
];

export const countries = [
  { name: i18next.t("country.AF"), code: "AF" },
  { name: i18next.t("country.AL"), code: "AL" },
  { name: i18next.t("country.DZ"), code: "DZ" },
  { name: i18next.t("country.AS"), code: "AS" },
  { name: i18next.t("country.AD"), code: "AD" },
  { name: i18next.t("country.AO"), code: "AO" },
  { name: i18next.t("country.AG"), code: "AG" },
  { name: i18next.t("country.AR"), code: "AR" },
  { name: i18next.t("country.AM"), code: "AM" },
  { name: i18next.t("country.AU"), code: "AU" },
  { name: i18next.t("country.AT"), code: "AT" },
  { name: i18next.t("country.AZ"), code: "AZ" },
  { name: i18next.t("country.BS"), code: "BS" },
  { name: i18next.t("country.BH"), code: "BH" },
  { name: i18next.t("country.BD"), code: "BD" },
  { name: i18next.t("country.BB"), code: "BB" },
  { name: i18next.t("country.BY"), code: "BY" },
  { name: i18next.t("country.BE"), code: "BE" },
  { name: i18next.t("country.BZ"), code: "BZ" },
  { name: i18next.t("country.BJ"), code: "BJ" },
  { name: i18next.t("country.BT"), code: "BT" },
  { name: i18next.t("country.BO"), code: "BO" },
  { name: i18next.t("country.BA"), code: "BA" },
  { name: i18next.t("country.BW"), code: "BW" },
  { name: i18next.t("country.BR"), code: "BR" },
  { name: i18next.t("country.BN"), code: "BN" },
  { name: i18next.t("country.BG"), code: "BG" },
  { name: i18next.t("country.BF"), code: "BF" },
  { name: i18next.t("country.BI"), code: "BI" },
  { name: i18next.t("country.KH"), code: "KH" },
  { name: i18next.t("country.CM"), code: "CM" },
  { name: i18next.t("country.CA"), code: "CA" },
  { name: i18next.t("country.CV"), code: "CV" },
  { name: i18next.t("country.CF"), code: "CF" },
  { name: i18next.t("country.TD"), code: "TD" },
  { name: i18next.t("country.CL"), code: "CL" },
  { name: i18next.t("country.CN"), code: "CN" },
  { name: i18next.t("country.CO"), code: "CO" },
  { name: i18next.t("country.KM"), code: "KM" },
  { name: i18next.t("country.CG"), code: "CG" },
  { name: i18next.t("country.CD"), code: "CD" },
  { name: i18next.t("country.CR"), code: "CR" },
  { name: i18next.t("country.HR"), code: "HR" },
  { name: i18next.t("country.CU"), code: "CU" },
  { name: i18next.t("country.CY"), code: "CY" },
  { name: i18next.t("country.CZ"), code: "CZ" },
  { name: i18next.t("country.DK"), code: "DK" },
  { name: i18next.t("country.DJ"), code: "DJ" },
  { name: i18next.t("country.DM"), code: "DM" },
  { name: i18next.t("country.DO"), code: "DO" },
  { name: i18next.t("country.EC"), code: "EC" },
  { name: i18next.t("country.EG"), code: "EG" },
  { name: i18next.t("country.SV"), code: "SV" },
  { name: i18next.t("country.GQ"), code: "GQ" },
  { name: i18next.t("country.ER"), code: "ER" },
  { name: i18next.t("country.EE"), code: "EE" },
  { name: i18next.t("country.ET"), code: "ET" },
  { name: i18next.t("country.FJ"), code: "FJ" },
  { name: i18next.t("country.FI"), code: "FI" },
  { name: i18next.t("country.FR"), code: "FR" },
  { name: i18next.t("country.GA"), code: "GA" },
  { name: i18next.t("country.GM"), code: "GM" },
  { name: i18next.t("country.GE"), code: "GE" },
  { name: i18next.t("country.DE"), code: "DE" },
  { name: i18next.t("country.GH"), code: "GH" },
  { name: i18next.t("country.GR"), code: "GR" },
  { name: i18next.t("country.GD"), code: "GD" },
  { name: i18next.t("country.GT"), code: "GT" },
  { name: i18next.t("country.GN"), code: "GN" },
  { name: i18next.t("country.GW"), code: "GW" },
  { name: i18next.t("country.GY"), code: "GY" },
  { name: i18next.t("country.HT"), code: "HT" },
  { name: i18next.t("country.HN"), code: "HN" },
  { name: i18next.t("country.HU"), code: "HU" },
  { name: i18next.t("country.IS"), code: "IS" },
  { name: i18next.t("country.IN"), code: "IN" },
  { name: i18next.t("country.ID"), code: "ID" },
  { name: i18next.t("country.IR"), code: "IR" },
  { name: i18next.t("country.IQ"), code: "IQ" },
  { name: i18next.t("country.IE"), code: "IE" },
  { name: i18next.t("country.IL"), code: "IL" },
  { name: i18next.t("country.IT"), code: "IT" },
  { name: i18next.t("country.CI"), code: "CI" },
  { name: i18next.t("country.JM"), code: "JM" },
  { name: i18next.t("country.JP"), code: "JP" },
  { name: i18next.t("country.JO"), code: "JO" },
  { name: i18next.t("country.KZ"), code: "KZ" },
  { name: i18next.t("country.KE"), code: "KE" },
  { name: i18next.t("country.KI"), code: "KI" },
  { name: i18next.t("country.KP"), code: "KP" },
  { name: i18next.t("country.KR"), code: "KR" },
  { name: i18next.t("country.KW"), code: "KW" },
  { name: i18next.t("country.KG"), code: "KG" },
  { name: i18next.t("country.LA"), code: "LA" },
  { name: i18next.t("country.LV"), code: "LV" },
  { name: i18next.t("country.LB"), code: "LB" },
  { name: i18next.t("country.LS"), code: "LS" },
  { name: i18next.t("country.LR"), code: "LR" },
  { name: i18next.t("country.LY"), code: "LY" },
  { name: i18next.t("country.LT"), code: "LT" },
  { name: i18next.t("country.LU"), code: "LU" },
  { name: i18next.t("country.MG"), code: "MG" },
  { name: i18next.t("country.MW"), code: "MW" },
  { name: i18next.t("country.MY"), code: "MY" },
  { name: i18next.t("country.MV"), code: "MV" },
  { name: i18next.t("country.ML"), code: "ML" },
  { name: i18next.t("country.MT"), code: "MT" },
  { name: i18next.t("country.MH"), code: "MH" },
  { name: i18next.t("country.MR"), code: "MR" },
  { name: i18next.t("country.MU"), code: "MU" },
  { name: i18next.t("country.MX"), code: "MX" },
  { name: i18next.t("country.FM"), code: "FM" },
  { name: i18next.t("country.MD"), code: "MD" },
  { name: i18next.t("country.MC"), code: "MC" },
  { name: i18next.t("country.MN"), code: "MN" },
  { name: i18next.t("country.ME"), code: "ME" },
  { name: i18next.t("country.MA"), code: "MA" },
  { name: i18next.t("country.MZ"), code: "MZ" },
  { name: i18next.t("country.MM"), code: "MM" },
  { name: i18next.t("country.NA"), code: "NA" },
  { name: i18next.t("country.NR"), code: "NR" },
  { name: i18next.t("country.NP"), code: "NP" },
  { name: i18next.t("country.NL"), code: "NL" },
  { name: i18next.t("country.NZ"), code: "NZ" },
  { name: i18next.t("country.NI"), code: "NI" },
  { name: i18next.t("country.NE"), code: "NE" },
  { name: i18next.t("country.NG"), code: "NG" },
  { name: i18next.t("country.NO"), code: "NO" },
  { name: i18next.t("country.OM"), code: "OM" },
  { name: i18next.t("country.PK"), code: "PK" },
  { name: i18next.t("country.PW"), code: "PW" },
  { name: i18next.t("country.PA"), code: "PA" },
  { name: i18next.t("country.PG"), code: "PG" },
  { name: i18next.t("country.PY"), code: "PY" },
  { name: i18next.t("country.PE"), code: "PE" },
  { name: i18next.t("country.PH"), code: "PH" },
  { name: i18next.t("country.PL"), code: "PL" },
  { name: i18next.t("country.PT"), code: "PT" },
  { name: i18next.t("country.QA"), code: "QA" },
  { name: i18next.t("country.RO"), code: "RO" },
  { name: i18next.t("country.RU"), code: "RU" },
  { name: i18next.t("country.RW"), code: "RW" },
  { name: i18next.t("country.KN"), code: "KN" },
  { name: i18next.t("country.LC"), code: "LC" },
  { name: i18next.t("country.VC"), code: "VC" },
  { name: i18next.t("country.WS"), code: "WS" },
  { name: i18next.t("country.SM"), code: "SM" },
  { name: i18next.t("country.ST"), code: "ST" },
  { name: i18next.t("country.SA"), code: "SA" },
  { name: i18next.t("country.SN"), code: "SN" },
  { name: i18next.t("country.RS"), code: "RS" },
  { name: i18next.t("country.SC"), code: "SC" },
  { name: i18next.t("country.SL"), code: "SL" },
  { name: i18next.t("country.SG"), code: "SG" },
  { name: i18next.t("country.SK"), code: "SK" },
  { name: i18next.t("country.SI"), code: "SI" },
  { name: i18next.t("country.SB"), code: "SB" },
  { name: i18next.t("country.SO"), code: "SO" },
  { name: i18next.t("country.ZA"), code: "ZA" },
  { name: i18next.t("country.ES"), code: "ES" },
  { name: i18next.t("country.LK"), code: "LK" },
  { name: i18next.t("country.SD"), code: "SD" },
  { name: i18next.t("country.SR"), code: "SR" },
  { name: i18next.t("country.SZ"), code: "SZ" },
  { name: i18next.t("country.SE"), code: "SE" },
  { name: i18next.t("country.CH"), code: "CH" },
  { name: i18next.t("country.SY"), code: "SY" },
  { name: i18next.t("country.TW"), code: "TW" },
  { name: i18next.t("country.TJ"), code: "TJ" },
  { name: i18next.t("country.TZ"), code: "TZ" },
  { name: i18next.t("country.TH"), code: "TH" },
  { name: i18next.t("country.TL"), code: "TL" },
  { name: i18next.t("country.TG"), code: "TG" },
  { name: i18next.t("country.TO"), code: "TO" },
  { name: i18next.t("country.TT"), code: "TT" },
  { name: i18next.t("country.TN"), code: "TN" },
  { name: i18next.t("country.TR"), code: "TR" },
  { name: i18next.t("country.TM"), code: "TM" },
  { name: i18next.t("country.TV"), code: "TV" },
  { name: i18next.t("country.UG"), code: "UG" },
  { name: i18next.t("country.UA"), code: "UA" },
  { name: i18next.t("country.AE"), code: "AE" },
  { name: i18next.t("country.GB"), code: "GB" },
  { name: i18next.t("country.US"), code: "US" },
  { name: i18next.t("country.UY"), code: "UY" },
  { name: i18next.t("country.UZ"), code: "UZ" },
  { name: i18next.t("country.VU"), code: "VU" },
  { name: i18next.t("country.VE"), code: "VE" },
  { name: i18next.t("country.VN"), code: "VN" },
  { name: i18next.t("country.YE"), code: "YE" },
  { name: i18next.t("country.ZM"), code: "ZM" },
  { name: i18next.t("country.ZW"), code: "ZW" },
];
